import { useEffect, useState } from "react";

import PropTypes from "prop-types";

import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";
import { PromotionCampaignFormDialog } from "../promotion-campaign-form-dialog";

import { Button } from "@mui/material";

export const EditPromotionCampaignFormDialog = ({
  isOpen,
  onClose,
  promotionCampaignId,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    if (!isOpen) return;

    const fetchPromotionCampaign = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: { name, description, status },
          },
        } = await apiClient.get(
          `promotion-campaigns/${promotionCampaignId}`
        );
        setDefaultValues({
          name,
          description,
          status,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchPromotionCampaign();
  }, [isOpen, promotionCampaignId]);

  const handleSubmit = async ({ name, description, status }) => {
    try {
      await apiClient.put(
        `promotion-campaigns/${promotionCampaignId}`,
        {
          name,
          description,
          status,
        }
      );

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memperbarui kampanye promosi"));

      throw error;
    }
  };

  return (
    <PromotionCampaignFormDialog
      isOpen={isOpen}
      onClose={onClose}
      dialogTitle="Ubah Kampanye Promosi"
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Simpan
        </Button>
      )}
    />
  );
};

EditPromotionCampaignFormDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
  promotionCampaignId: PropTypes.string,
};
